// Reusable "label + value" stat tile. Value is passed as children for parent-side formatting.

import React from "react";
import { Typography } from "@material-tailwind/react";

export function StatTile({ label, children }) {
    return (
        <div className="bg-platinumlight p-4 rounded-lg">
            <Typography className="font-semibold text-black">
                {label}
            </Typography>
            <Typography className="text-black">
                {children}
            </Typography>
        </div>
    );
}
